export const formatResponseDataToTaskBannerEligibility = (data) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { currentAccount } = data;
    const taskBufferOverride = currentAccount.taskBufferOverride;
    const planHasMeteredBilling = ((_a = currentAccount.plan.meteredPricingTiers) === null || _a === void 0 ? void 0 : _a.length) > 0;
    const accountHasMeteredBilling = Boolean(((_b = currentAccount.entitlements) === null || _b === void 0 ? void 0 : _b.limits.payPerTaskEnabled) &&
        planHasMeteredBilling);
    const accountConsumedTasks = ((_e = (_d = (_c = currentAccount.entitlements) === null || _c === void 0 ? void 0 : _c.quotas) === null || _d === void 0 ? void 0 : _d.tasks) === null || _e === void 0 ? void 0 : _e.count) || 0;
    const meteredPricingTaskLimit = ((_h = (_g = (_f = currentAccount.plan) === null || _f === void 0 ? void 0 : _f.meteredPricingTiers) === null || _g === void 0 ? void 0 : _g.find((tier) => tier.pricePerTask === 0)) === null || _h === void 0 ? void 0 : _h.numTasks) || 0;
    const nonMeteredPricingTaskLimit = ((_l = (_k = (_j = currentAccount.entitlements) === null || _j === void 0 ? void 0 : _j.quotas) === null || _k === void 0 ? void 0 : _k.tasks) === null || _l === void 0 ? void 0 : _l.limit) || 0;
    const includedTasksPerMonth = planHasMeteredBilling
        ? meteredPricingTaskLimit
        : nonMeteredPricingTaskLimit;
    return {
        accountHasMeteredBilling,
        includedTasksPerMonth,
        accountConsumedTasks,
        taskBufferOverride,
    };
};
//# sourceMappingURL=formatResponseDataToTaskBannerEligibility.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
